<template>
  <div :style="{height: height, width: width, position: assess === false ? 'relative' : 'absolute'}" id="mapWrapper">
    <v-toolbar v-if="mark" dense color="primary" dark>
      <v-btn @click="emitInstruction('toggle-candidate-route')" color="info" depressed>
        Toggle Candidate Route
      </v-btn>
      <v-btn @click="emitInstruction('toggle-assessor-route')" outlined color="gx_green" class="ml-2">
        Toggle Answer Routes
      </v-btn>
      <v-btn @click="emitInstruction('toggle-comments')" outlined color="white" class="ml-2">
        Toggle Comments
      </v-btn>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn @click="handleOpacityDown" v-on="on" depressed color="primary">
            <v-icon>{{ getBrightnessIcon }}</v-icon>
          </v-btn>
        </template>
        <span>Opacity: {{ currentOpacity }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn @click="handleGoHome" v-on="on" depressed color="primary">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>Back to 'Home'</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn @click="handlePrint" v-on="on" depressed color="primary">
            <v-icon>mdi-camera_alt</v-icon>
          </v-btn>
        </template>
        <span>Snapshot</span>
      </v-tooltip>
    </v-toolbar>
    <v-toolbar v-if="!assess && !mark" dense color="primary" dark flat height="35">
      <v-toolbar-title v-if="title">{{ title }}</v-toolbar-title>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn depressed icon tile
                 @click="handleMapToolbarUndo" :disabled="noUndo" v-on="on">
            <v-icon>mdi-undo</v-icon>
          </v-btn>
        </template>
        <span>Undo</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn depressed icon tile
                 @click="handleMapToolbarClear" v-on="on">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <span>Clear</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn depressed icon tile
                 @click="handleOpacityDown" v-on="on">
            <v-icon>{{ getBrightnessIcon }}</v-icon>
          </v-btn>
        </template>

        <span>Opacity: {{ currentOpacity }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-btn depressed icon
                 @click="handleGoHome" v-on="on">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>

        <span>Back to 'Home'</span>
      </v-tooltip>
    </v-toolbar>
    <v-toolbar v-if="assess" dense color="primary" dark>
      <v-layout v-if="states.headerMessage">
        <v-alert type="warning" :value="true" @click="handleHeaderMessageCallback">
          <span :style="{color: $vuetify.theme.primary}">
          {{ states.headerMessage }}
          </span>
        </v-alert>
      </v-layout>
      <v-row v-if="!states.headerMessage">
        <div v-if="states.startDraw" class="text-xs-center">
          <v-btn @click.native="handleStartDrawing" color="success" slot="activator">
            Start Drawing
          </v-btn>
        </div>
        <div v-if="states.stopDraw" class="text-xs-center">
          <v-btn @click.native="handleStopDrawing" color="warning" slot="activator">
            Stop Drawing
          </v-btn>
        </div>
        <div v-if="states.continueDraw" class="text-xs-center">
          <v-btn @click.native="handleContinueDrawing" class="ml-2" :disabled="states.stopModify"
                 color="success"
                 slot="activator">
            Resume Drawing
          </v-btn>
        </div>
        <div class="text-xs-center">
          <v-btn :disabled="!states.undo" class="ml-2" @click="handleMapToolbarUndo" color="info"
                 slot="activator">
            Undo
          </v-btn>
        </div>
        <div class="text-xs-center">
          <v-btn @click="handleMapToolbarClear" class="ml-2" color="error" slot="activator">
            Clear
          </v-btn>
        </div>
        <v-tooltip bottom>
          <v-btn outlined color="gx_green" class="ml-2" @click="handleOpacityDown" slot="activator" flat>
            Brightness
          </v-btn>
          <span>Opacity: {{ currentOpacity }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn outlined color="gx_green" class="ml-2" @click="handleGoHome" slot="activator" flat>
            Home
          </v-btn>
          <span>Zoom to the Question start/end points</span>
        </v-tooltip>
        <v-spacer>
        </v-spacer>
        <v-btn @click="handleRefresh" @contextmenu="handleRefresh" depressed color="primary">&nbsp</v-btn>
      </v-row>
    </v-toolbar>
    <div id="map">
      <v-alert dismissible outlined
               @input="commentAlertChange"
               class="commentMap"
               type="info"
               v-model="commentSelected"
               transition="scale-transition"
      >{{ selectedCommentText }}
      </v-alert>
      <v-alert dismissible outlined
               class="commentMap"
               type="info"
               v-model="routeSelected"
               transition="scale-transition"
      >{{ selectedRouteScore }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import bus from '../bus'
import 'gox'
import {XYZ} from 'gox/src/layer/xyz.js'
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'MapComponent',

  props: {
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    assess: {
      type: Boolean,
      default: false
    },
    mark: {
      type: Boolean,
      default: false
    },
    noUndo: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    },
    selectLayers: {
      type: Array,
      default() {
        return []
      }
    },
    states: {
      type: Object,
      default() {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    },
    modify: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      map: {},
      isDrawing: false,
      commentSelected: false,
      routeSelected: false,
      selectedCommentText: '',
      selectedRouteScore: '',
      interactions: {
        select: null
      },
      baseMap: null,
      opacityValues: [0.25, 0.66, 1]
    }
  },
  computed: {
    ...mapGetters(['getHomeLocation', 'getCreatorMapOpacity', 'GET_SELECTED_RESULT_AND_PARTICIPANT', 'GET_SELECTED_BASEMAP']),
    currentOpacity() {
      if (this.baseMap === null)
        return;

      return this.baseMap.getOpacity() * 100;
    },
    getBrightnessIcon() {
      if (this.baseMap === null)
        return 'mdi-brightness-7';

      var opac = this.baseMap.getOpacity();
      if (opac === 0.25)
        return 'mdi-brightness-5';

      if (opac === 0.66)
        return 'mdi-brightness-6';

      if (opac === 1)
        return 'mdi-brightness-7'
    }
  },

  mounted() {
    this.createMap().then(() => {

      //set up the map click event used in the assess part
      this.map.on('singleclick', (e) => {
        //Clear the select interaction
        this.map.gox_interactions.select.getFeatures().clear();
        this.$emit('map-click', e);
      });

      this.addInteractions();
    });
  },

  watch: {
    select(nV) {
      console.log("SELECT CHANGED: " + nV)
      nV === true ? this.interactions.select.enable(this.selectLayers) : this.interactions.select.disable();
    },
    GET_SELECTED_BASEMAP() {
      this.changeBaseLayer();
    }
  },

  methods: {
    ...mapMutations(['setCreatorMapOpacity']),
    changeBaseLayer() {

      if (this.baseMap) {
        this.map.removeLayer(this.baseMap)
      }

      this.baseMap = new GOX.Layer.XYZ({
        url:  this.GET_SELECTED_BASEMAP || 'https://azmaps.xmap.cloud/epoch18/{z}/{x}/{y}.png'
      });

      /*        this.baseMap = new GOX.Layer.WMTSBasic({
                url: process.env.VUE_APP_GEOSERVER_BASE_URL + '?key=35287a34-ad33-4643-816d-334c9766de29',
                epsg: "EPSG:27700",
                layer: this.GET_SELECTED_BASEMAP || 'az:az_stack_tfl',
                opacity: this.getCreatorMapOpacity || 0.66,
                crossOrigin: 'use-credentials'
              });*/

      this.map.addLayer(this.baseMap);
    },
    handleRefresh() {
      console.log("REFRESH");
      this.map.removeLayer(this.baseMap);

      this.baseMap = new GOX.Layer.XYZ({
        url:  this.GET_SELECTED_BASEMAP || 'https://azmaps.xmap.cloud/epoch18/{z}/{x}/{y}.png'
      });

      this.baseMap.setZIndex(0)

      this.map.addLayer(this.baseMap)

    },
    checkState(state) {
      if (this.states.hasOwnProperty('undo')) {
        return this.states
      } else {
        return true
      }
    },
    commentAlertChange(val) {
      console.log("Comment Val")
      console.log(val);
      if (!val) {
        this.$emit('selected', {
          selected: []
        });
      }
    },
    emitInstruction(inst) {
      this.$emit(inst);
    },
    handleStartDrawing() {
      this.states.draw = true;
      this.$emit("assess-start-draw");
    },
    handleStartModify() {
      this.states.modify = false;
      this.$emit("assess-start-modify");
    },
    handleStopModify() {
      this.states.modify = false;
      this.$emit("assess-stop-modify");
    },
    handleStopDrawing() {
      this.states.draw = false;
      this.$emit("assess-stop-draw");
    },
    handleContinueDrawing() {
      this.states.draw = false;
      this.$emit("assess-continue-draw");
    },
    handleGoHome() {
      this.$emit('go-home');
    },
    handleHeaderMessageCallback() {
      if (this.states.returnToLastDrawnPoint && typeof this.states.returnToLastDrawnPoint == 'function') {
        this.states.returnToLastDrawnPoint();
      }
    },
    handleMapToolbarClear() {
      this.$emit('map-toolbar-clear');
    },
    handleMapToolbarUndo() {
      this.$emit('map-toolbar-undo');
    },
    handleOpacityDown() {
      var currentOpac = this.baseMap.getOpacity();
      var idx = this.opacityValues.indexOf(currentOpac);
      console.log('idx: ' + idx);

      var nextIdx = idx === this.opacityValues.length - 1 ? 0 : idx + 1;

      this.baseMap.setOpacity(this.opacityValues[nextIdx]);
      this.setCreatorMapOpacity(this.opacityValues[nextIdx]);
    },
    checkForComments(selected) {
      console.log('check comment');
      console.dir(selected)
      this.hideAllComments();

      if (!selected) {
        return
      }

      selected.forEach((feature) => {
        console.dir(feature);
        if (this.mark) {
          var comment = feature.get('text') || feature.get('value');
        } else {
          var comment = feature.get('text');
        }
        comment !== undefined ? this.showComment(comment) : '';
      })
    },
    showComment(comment) {
      this.commentSelected = true;
      this.selectedCommentText = comment;
    },
    showScore(score) {
      this.routeSelected = true;
      this.selectedRouteScore = score;
    },
    hideAllComments() {
      this.commentSelected = false;
      this.selectedCommentText = '';
      this.routeSelected = false;
      this.selectedRouteScore = ''
    },
    addInteractions() {
      console.log("Map -- addInteractions: ");
      this.interactions.select = new GOX.Select({
        hitTolerance: 15
      });
      // we can lock the modify interaction to the select function in here
      this.interactions.select.on('select', (e) => {
        console.log("GOX SELECT");
        console.dir(e);
        this.$emit('selected', e);
        this.checkForComments(e.selected);
        //this.checkForScores(e.selected);
        /*          var modifyInteraction = new GOX.Modify(null, this.interactions.select.getFeatures());
         modifyInteraction.start();*/
      });

      this.map.gox_interactions = {
        select: this.interactions.select,
        modify: this.interactions.modify
      };

      if (this.select)
        this.interactions.select.enable(this.map, this.selectLayers);

      console.log("Map -- addInteractions: emit");
      this.$emit('map-created', this.map);

    },
    createMap() {
      return new Promise((resolve, reject) => {
        /*let XYZ = 'https://api.mapbox.com/styles/v1/huntleth/cj03uk7au008r2sny7gv7pdev/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaHVudGxldGgiLCJhIjoiMzlhMjgwZWE5YTFjMmNhMjc3OTNkMGZmMjMzYjlkMWUifQ.WRJIVjyTMiQCnZvhFjSVFA';*/
        //let WMTS = 'http://feeds.xmap.cloud/gwc/service/wmts?user=dGZsOnRmbDEyM19QYW5kYSE=&v=' + Math.random() ;
        //let WMTS = 'https://77.68.79.199/gwc/service/wmts'

        let url = process.env.VUE_APP_GEOSERVER_BASE_URL


        var coords = this.$store.getters.getHomeLocation;
        var center = GOX.Transform([coords.lng, coords.lat], 'EPSG:4326', 'EPSG:27700');

        this.map = new GOX.Map({
          projection: "EPSG:27700",
          center: center,
          minZoom: 8,
          maxZoom: 21,
          doubleClickZoom: this.assess !== true,
          extent: [491666, 144580, 567511, 202032]
        });

        this.changeBaseLayer();

        resolve();
      })
    },
    handlePrint() {
      this.map.once('postcompose', (event) => {
        var canvas = event.context.canvas;
        var fileName = this.GET_SELECTED_RESULT_AND_PARTICIPANT.participant + "_" + this.GET_SELECTED_RESULT_AND_PARTICIPANT.result;
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(canvas.msToBlob(), fileName + '.png');
        } else {
          canvas.toBlob(function (blob) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName + ".png";
            a.click();
            window.URL.revokeObjectURL(url);
          });
        }
      });
      this.map.renderSync();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#mapWrapper {
  position: relative;
  height: 100%;
  width: 100%;
  left: 0px;
}

#map {
  position: relative;
  height: calc(100% - 48px);
}

.commentMap {
  position: absolute;
  background-color: white !important;
  width: 90%;
  left: 5%;
  z-index: 999;
}
</style>
